import React from 'react';
import {useFormikContext} from "formik";
import {useActions} from "../../../actions";
import * as EstimationActions from "../../../actions/estimation";
import {isDebug} from "../../../utils/commonUtils";
import {AllianzLifeCarrierDetail} from "../../../constants";


const UpdateMinimumContribution = (props: any) => {
    const { isNfIul } = props;
    const estimationActions = useActions(EstimationActions);

    const getMinContribution = async (query: any) => {
        await estimationActions.getMinimumContribution(query, isNfIul);
    };

    const {
        values: {
            carrierId,
            contributionFrequency,
            gender,
            healthType,
            issueAge,
            tobacco,
        }
    }: any = useFormikContext();

    isDebug() && console.log(gender, tobacco, healthType);

    React.useEffect(() => {
        let health: string = healthType || "Standard";
        let tobaccoCons: string = tobacco === "used" ? "Tobacco" : "NT";
        let rateClass: string = `${health}_${tobaccoCons}`;
        if (tobaccoCons === "NT" && healthType === "Preferred" && carrierId === AllianzLifeCarrierDetail.value) {
            rateClass = "Elite_NT";
        }
        let frequency: string = contributionFrequency && contributionFrequency.toLowerCase() || null;
        if (!!rateClass && gender && issueAge && frequency) {
            let query: any = {rateClass, gender, issueAge, carrierId: 3, frequency, groupId: "iul"};
            getMinContribution(query).then();
        }
    }, [gender, tobacco, healthType, issueAge, contributionFrequency]);
    return <></>;
};


export default UpdateMinimumContribution;

